var map = {
	"./admin/reducer.js": 382,
	"./album/reducer.js": 615,
	"./announcement/reducer.js": 614,
	"./class/reducer.js": 395,
	"./customer/reducer.js": 396,
	"./homework/reducer.js": 613,
	"./organization/reducer.js": 397,
	"./posts/reducer.js": 398,
	"./resource/reducer.js": 399,
	"./school/reducer.js": 603,
	"./sessions/reducer.js": 400,
	"./teacher/reducer.js": 401,
	"./user/reducer.js": 402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;